import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import OrganisationPlayersTable from '../components/OrganisationPlayersTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';

import axios from 'axios';
import {
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup,
    DropdownButton,
    MenuItem
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './OrganisationPlayers.css';

class OrganisationPlayers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            players: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            selectedPlayers: new Set(),
            selectedPlayersData: new Map(),
            selectAllMode: false,
            selectAllPages: false,
            totalPlayers: 0,
            excludedPlayers: new Set(),
            excludedPlayersData: new Map()
        };
    }

    componentDidMount() {

        this.loadOrganisationInformation();
        this.loadOrganisationPlayersFromServer();
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationPlayersFromServer() {
        var self = this;
        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}/players`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                console.log(`Response: ${JSON.stringify(response)}`);
                self.setState({
                    players: response.data.players,
                    pageCount: response.data.pageCount,
                    totalPlayers: response.data.itemCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadOrganisationPlayersFromServer();
        });
    };

    handleChange = event => {

        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url); 

        event.preventDefault();
        this.loadOrganisationPlayersFromServer();
    };

    deletePlayer(player) {
        var self = this;
        axios
            .delete(`${config.baseURL}/players/${player.uuid}`)
            .then(function(response) {
                self.loadOrganisationPlayersFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handleSelectPlayer = (playerUuid, isSelected) => {
        let selectedPlayers = new Set(this.state.selectedPlayers);
        let selectedPlayersData = new Map(this.state.selectedPlayersData);
        let excludedPlayers = new Set(this.state.excludedPlayers);
        let excludedPlayersData = new Map(this.state.excludedPlayersData);

        if (isSelected) {
            if (this.state.selectAllMode) {
                excludedPlayers.delete(playerUuid);
                excludedPlayersData.delete(playerUuid);
            } else {
                selectedPlayers.add(playerUuid);
                const playerData = this.state.players.find(p => p.uuid === playerUuid);
                if (playerData) {
                    selectedPlayersData.set(playerUuid, playerData);
                }
            }
        } else {
            if (this.state.selectAllMode) {
                excludedPlayers.add(playerUuid);
                const playerData = this.state.players.find(p => p.uuid === playerUuid);
                if (playerData) {
                    excludedPlayersData.set(playerUuid, playerData);
                }
            } else {
                selectedPlayers.delete(playerUuid);
                selectedPlayersData.delete(playerUuid);
            }
        }

        this.setState({
            selectedPlayers,
            selectedPlayersData,
            excludedPlayers,
            excludedPlayersData
        });
    };

    handleSelectAll = (isSelectAll) => {
        if (isSelectAll) {
            // Select all items on current page only - DON'T set selectAllMode yet
            const currentPagePlayerUuids = new Set(this.state.players.map(p => p.uuid));
            const currentPagePlayersData = new Map(this.state.players.map(p => [p.uuid, p]));

            this.setState({
                selectAllMode: false,  // Keep this false - only for current page
                selectAllPages: false,
                selectedPlayers: currentPagePlayerUuids,
                selectedPlayersData: currentPagePlayersData,
                excludedPlayers: new Set(),
                excludedPlayersData: new Map()
            });
        } else {
            this.setState({
                selectAllMode: false,
                selectAllPages: false,
                selectedPlayers: new Set(),
                selectedPlayersData: new Map(),
                excludedPlayers: new Set(),
                excludedPlayersData: new Map()
            });
        }
    };

    handleSelectAllPages = () => {
        this.setState({
            selectAllMode: true,   // NOW we set selectAllMode true
            selectAllPages: true,
            selectedPlayers: new Set(),
            selectedPlayersData: new Map()
        });
    };

    showBulkDeleteConfirmation = () => {
        const { t } = this.props;

        let bodyContent;

        if (this.state.selectAllPages) {
            const effectiveCount = this.state.totalPlayers - this.state.excludedPlayers.size;
            bodyContent = (
                <div>
                    <p><strong>Warning: This will delete {effectiveCount} players across all pages!</strong></p>
                    <p>This includes all players that match your current search {this.state.search ? ` for "${this.state.search}"` : ''}
                    {this.state.excludedPlayers.size > 0 && <span>, excluding {this.state.excludedPlayers.size} manually deselected items</span>}.</p>
                    <p><em>This action cannot be undone.</em></p>
                </div>
            );
        } else {
            const selectedItems = Array.from(this.state.selectedPlayersData.values());
            bodyContent = (
                <div>
                    <p><strong>This will delete {selectedItems.length} selected player{selectedItems.length === 1 ? '' : 's'}:</strong></p>
                    <ul style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                        {selectedItems.map(item => (
                            <li key={item.uuid}><strong>{item.name}</strong> ({item.location})</li>
                        ))}
                    </ul>
                </div>
            );
        }

        this.dialog.show({
            title: t('Dialog.warning'),
            body: bodyContent,
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => this.dialog.hide(),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.confirmBulkDelete(),
                    'btn-danger'
                )
            ],
            bsSize: 'large'
        });
    };

    handleBulkDelete = () => {
        this.showBulkDeleteConfirmation();
    };

    confirmBulkDelete = () => {
        const { uuid } = this.props.match.params;

        // Determine if we're using "select all" mode (either current page or all pages)
        const usingSelectAll = this.state.selectedPlayers.size > 0 || this.state.selectAllPages;

        const payload = {
            selectAll: usingSelectAll,
            selectAllPages: this.state.selectAllPages,
            search: this.state.search,
            players: this.state.selectAllPages ? [] : Array.from(this.state.selectedPlayers),
            excludedPlayers: this.state.selectAllPages ? Array.from(this.state.excludedPlayers) : []
        };

        console.log('🔍 BULK DELETE PAYLOAD:', {
            selectAll: payload.selectAll,
            selectAllPages: payload.selectAllPages,
            playersCount: payload.players.length,
            players: payload.players,
            excludedPlayersCount: payload.excludedPlayers.length,
            search: payload.search,
            state: {
                selectedPlayersSize: this.state.selectedPlayers.size,
                selectAllPages: this.state.selectAllPages,
                totalPlayers: this.state.totalPlayers
            }
        });

        const wasSelectAllPagesWithSearch = this.state.selectAllPages && this.state.search;

        axios
            .post(`${config.baseURL}/organisations/${uuid}/players/bulk-delete`, payload)
            .then((response) => {
                const newState = {
                    selectedPlayers: new Set(),
                    selectedPlayersData: new Map(),
                    excludedPlayers: new Set(),
                    excludedPlayersData: new Map(),
                    selectAllMode: false,
                    selectAllPages: false
                };

                if (wasSelectAllPagesWithSearch) {
                    newState.search = '';

                    const url = new URL(window.location.href);
                    url.searchParams.delete('search');
                    window.history.pushState(null, null, url);
                }

                this.setState(newState, () => {
                    this.loadOrganisationPlayersFromServer();
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'OrganisationPlayers.title'
        )}`;

        const selectedCount = this.state.selectAllPages
            ? this.state.totalPlayers - this.state.excludedPlayers.size
            : this.state.selectedPlayers.size;
        const hasSelection = selectedCount > 0;

        // Show banner when: all items on current page are selected AND there are more pages
        const allCurrentPageSelected = this.state.selectedPlayers.size === this.state.players.length && this.state.players.length > 0;
        const showSelectAllPagesBanner = allCurrentPageSelected && !this.state.selectAllPages && this.state.totalPlayers > this.state.players.length;

        const user = this.state.user;
        const { uuid } = this.props.match.params;

        return (
            <div className="OrganisationPlayers">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                            <div className="page-header">
                                    <h1>
                                        {t('OrganisationPlayers.title')}{' '}
                                        <small>
                                            {this.state.organisation_name}
                                        </small>
                                    </h1>
                                    <div className="header-pagination">
                                <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    </div>
                                    <div>
                                    {this.state.userIsAuthorized(user, [
                                        'staff_super_admin',
                                        'staff_admin'
                                    ]) ? (
                                        <Link
                                            type="submit"
                                            className="btn btn-primary header-button"
                                            to={`/organisations/${uuid}/players/create`}
                                        >
                                            <em className="fa fa-plus fa-fw" />{' '}
                                            {t('Players.add_player')}
                                        </Link>
                                    ) : null}
                                    <DropdownButton
                                        bsStyle={'primary'}
                                        title={
                                            <span>
                                                <em className="fa fa-download fa-fw" />{' '}
                                                {t(
                                                    'Players.download_csv'
                                                )}
                                            </span>
                                        }
                                    >
                                        <MenuItem
                                            eventKey="1"
                                            onClick={() => {
                                                 window.open(`${config.baseURL}/organisations/${uuid}/playerscsv`, "_blank");
                                             }
                                            }
                                        >
                                            {t('Players.download_csv_all')}
                                        </MenuItem>
                                        <MenuItem
                                            eventKey="2"
                                            onClick={() => {
                                                 window.open(`${config.baseURL}/organisations/${uuid}/playerscsvoffline`, "_blank");
                                             }
                                            }
                                        >
                                            {t(
                                                'Players.download_csv_offline'
                                            )}
                                        </MenuItem>
                                    </DropdownButton>
                                    </div>
                                </div>


                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${uuid}`}>
                                            {t('Dashboard.title')}
                                        </Link>
                                    </li>

                                    <li className="active">
                                        <i className="fa fa-tv" />{' '}
                                        {t('SideNavigation.players')}
                                    </li>
                                </ol>

                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px' }}>
                                                    <form
                                                        role="search"
                                                        onSubmit={this.handleSubmit}
                                                        style={{ flex: hasSelection ? 1 : 1 }}
                                                    >
                                                        <FormGroup controlId="search" style={{ margin: 0 }}>
                                                            <InputGroup style={{ height: '38px' }}>
                                                                <FormControl
                                                                    type="text"
                                                                    value={this.state.search}
                                                                    onChange={this.handleChange}
                                                                    placeholder={t('Search')}
                                                                    style={{ height: '38px' }}
                                                                />
                                                                <InputGroup.Button>
                                                                    <Button
                                                                        onClick={this.handleSubmit}
                                                                        style={{ height: '38px' }}
                                                                    >
                                                                        <i className="glyphicon glyphicon-search" />
                                                                    </Button>
                                                                </InputGroup.Button>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </form>

                                                    {hasSelection && this.state.userIsAuthorized(user, ['staff_super_admin']) && (
                                                        <div className="alert alert-info" style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            margin: 0,
                                                            padding: '8px 16px',
                                                            fontSize: '14px',
                                                            whiteSpace: 'nowrap',
                                                            flex: 2,
                                                            minWidth: '350px',
                                                            height: '38px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            <span>
                                                                <strong>{selectedCount}</strong> player{selectedCount === 1 ? '' : 's'} selected
                                                                {this.state.selectAllPages && <span> (all pages)</span>}
                                                                {showSelectAllPagesBanner && (
                                                                    <span>
                                                                        {' '}
                                                                        <a
                                                                            href="#"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.handleSelectAllPages();
                                                                            }}
                                                                            style={{ textDecoration: 'underline', color: '#31708f', fontWeight: 'bold' }}
                                                                        >
                                                                            Select all {this.state.totalPlayers} players?
                                                                        </a>
                                                                    </span>
                                                                )}
                                                            </span>
                                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                                <Button
                                                                    className="btn-default btn-sm"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            selectedPlayers: new Set(),
                                                                            selectedPlayersData: new Map(),
                                                                            excludedPlayers: new Set(),
                                                                            excludedPlayersData: new Map(),
                                                                            selectAllMode: false,
                                                                            selectAllPages: false
                                                                        });
                                                                    }}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className='far fa-square' /> {t('MediaSnippetMediaLibrary.select_none')}
                                                                </Button>
                                                                <Button
                                                                    className="btn-danger btn-sm"
                                                                    onClick={this.handleBulkDelete}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className="fa fa-trash" /> Delete Selected
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <OrganisationPlayersTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        players={this.state.players}
                                        uuid={uuid}
                                        onDelete={this.deletePlayer.bind(this)}
                                        onSelectPlayer={this.handleSelectPlayer}
                                        onSelectAll={this.handleSelectAll}
                                        selectedPlayers={this.state.selectedPlayers}
                                        excludedPlayers={this.state.excludedPlayers}
                                        selectAllMode={this.state.selectAllMode}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(OrganisationPlayers);
